/// <reference path="../../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "../../../../../Intercom.ReactUI/Views/index";
import {BotService} from "../../../Generated/RestClient";

export interface V3UpdateProps extends React.Props<V3Update> {
    bot: BotService;
}

export class V3Update extends React.Component<V3UpdateProps, {}> {
    constructor(props) {
        super(props);
    }

    public render(): JSX.Element {
        if (this.props.bot.Version === '1.0') {
            return (
                <div className="status-bar warn">
                    {resourceStrings.v3Update} <a href="https://aka.ms/bf-migrate" target="_blank">Learn&nbsp;how</a>
                </div>
            );
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/status/V3Update.tsx